
export default 'https://react-online-shopping-heroku.herokuapp.com';
